/* eslint-disable import/no-cycle */
import { setSelectedPipe, setSelectedPipeChangesClone } from './actions';
import { ROOT_SLICE } from './constants';
import { selectRootSlice } from './selectors';

// ************
// PARTS
// ************
const reducerParts = {
	[setSelectedPipe]: (state, { payload: { selectedPipe } }) => {
		const rootSlice = selectRootSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, selectedPipe }
		};
	},

	[setSelectedPipeChangesClone]: (
		state,
		{ payload: { selectedPipeChangesClone } }
	) => {
		const rootSlice = selectRootSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, selectedPipeChangesClone }
		};
	}
};

export default reducerParts;
